module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA80lEQVQ4T8XUsWrDMBAG4DuEMhfaoWMeINAXMIizTaZAIWP2vEDfrUtwdPYSOrWTAx2yZjKdsl4UBJ2KYjvhoFrF/wmh04+gvDDlMfMTEXX3nJUE67pei4gviuJwK5oEvfdvETLGsHPu6xY0CUagaZqViDwj4icR1WPRq2AEvPcFALwAwAERt0R0GoJ7wRhm5lkIYY6IP9baTZZlxz50EPxFpyGEJSKeRWRTluX+GjoKjOGqqh6tta8i8mCM+XDO7VLoaDCG27addF23EJEpAHznef7+F/0/UPXKzKz3KKpjozrYql9PvRzU60u9YIcapW//AhVsjhXx9C7cAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/icon_right.png
// module id = 5R64
// module chunks = 1